/**
 * Textes du module « Ouvertures » (ARTO-128) : la liste, l'assistant en six
 * étapes et la fiche dossier. Fichier à part pour ne pas alourdir `i18n.ts` ;
 * son bloc est fusionné dans le namespace `console` (D15).
 * Voix 2.2 : phrases courtes, un verbe d'action sur chaque bouton.
 */

export const frOuvertures = {
  ouvertures: {
    titre: 'Ouvertures',
    texte: 'Les dossiers de mise en service, de l’offre signée à la galerie ouverte.',
    nouvelle: 'Nouvelle ouverture',
    retour: 'Retour aux ouvertures',
    chargement: 'Chargement des dossiers…',
    erreurChargement: 'Impossible de lire les dossiers d’ouverture.',
    introuvable: 'Ce dossier d’ouverture est introuvable.',
    vide: 'Aucun dossier ne correspond à ces filtres.',
    videTout: 'Aucun dossier d’ouverture pour l’instant. Commencez par une nouvelle ouverture.',
    test: 'Test',
    filtres: {
      etat: 'État',
      tousEtats: 'Tous les états',
      responsable: 'Responsable',
      tous: 'Tous',
      moi: 'Mes dossiers',
    },
    colonnes: {
      numero: 'Dossier',
      nom: 'Galerie',
      etat: 'État',
      responsable: 'Responsable',
      bascule: 'Bascule prévue',
      prochaine: 'Prochaine action',
    },
    pagination: {
      page: 'Page {{page}} sur {{total}}',
      precedente: 'Page précédente',
      suivante: 'Page suivante',
    },
    sansResponsable: 'Non attribué',
    sansDate: 'Non planifiée',
    retard_one: 'En retard de {{count}} jour',
    retard_other: 'En retard de {{count}} jours',
    etat: {
      brouillon: 'Brouillon',
      contrat_signe: 'Contrat signé',
      provisionne: 'Provisionnée',
      reprise: 'Reprise des données',
      recette: 'Recette',
      bascule_planifiee: 'Bascule planifiée',
      en_service: 'En service',
      abandonne: 'Abandonné',
    },
    prochaineAction: {
      brouillon: 'Terminer l’assistant',
      brouillonTest: 'Créer l’espace de test',
      contrat_signe: 'Créer la galerie',
      provisionne: 'Lancer la reprise des données',
      reprise: 'Suivre la reprise des données',
      recette: 'Faire la recette',
      bascule_planifiee: 'Préparer la bascule',
      en_service: 'Aucune',
      abandonne: 'Aucune',
    },
    erreurs: {
      generique: 'L’opération a échoué. Réessayez.',
      reseau: 'La connexion à la console a échoué. Réessayez.',
      droits: 'Votre rôle ne permet pas ce geste.',
      dossier_clos: 'Ce dossier est clos (en service ou abandonné) : il ne se modifie plus.',
      slug_fige: 'La galerie est créée : son identifiant ne change plus.',
      slug_pris: 'Cet identifiant est déjà pris.',
      contrat_incomplet: 'Indiquez la référence du contrat et sa date de signature.',
      provisionnement_incomplet: 'La galerie n’est pas entièrement créée : terminez la création.',
      transition_interdite: 'Ce dossier ne peut pas passer à cet état depuis son état actuel.',
      bascule_requise: 'La mise en service ne passe que par la bascule, depuis l’onglet Recette.',
      lots_non_termines:
        'Des lots ne sont pas terminés : {{lots}}. Lancez-les ou annulez-les ; un lot jamais lancé se met de côté en passant à la recette avec un motif.',
      reprise_en_cours:
        'Un plan ou un travail de reprise occupe encore la galerie : attendez qu’il se termine.',
      galerie_absente: 'Ce dossier n’a pas encore de galerie : rien à recetter.',
      validation_requise:
        'La galerie n’a pas validé la reprise. Attendez sa validation, ou posez une dérogation (direction de Venio) depuis l’onglet Recette.',
      bascule_non_datee: 'Indiquez la date de bascule prévue, dans la synthèse du dossier.',
      recette_non_ouverte: 'La reprise n’est pas en recette : il n’y a rien à valider.',
      invitations_non_envoyees:
        'Des invitations ne sont pas parties. Les étapes faites sont gardées : reprenez la bascule.',
      delta_inacheve: 'Des lots sont lancés sans être terminés : le contrôle final n’est pas fait.',
      bascule_en_cours: 'La bascule de cette galerie est déjà en cours ou a été reprise ailleurs.',
      mandat_concurrent: 'Le mandat vient de changer : reprenez la bascule.',
      lot_modifie: 'Un lot vient de changer : rechargez puis recommencez.',
      dossier_incomplet: 'Le dossier ne suffit pas à créer la galerie. Il manque : {{manquants}}.',
      creation_en_cours:
        'La création de cette galerie est déjà en cours. Patientez, puis reprenez.',
      etat_incompatible:
        'La galerie se crée une fois le contrat signé, ou d’emblée pour un espace de test.',
      module_non_disponible: 'Un module de l’offre n’est pas encore livré.',
      addon_echeance_passee: 'L’échéance d’un add-on est passée : corrigez l’offre.',
      membre_en_double: 'Une même adresse figure deux fois dans l’équipe.',
      role_plateforme_existant:
        'Cette adresse porte déjà un rôle de plateforme : elle ne peut pas rejoindre une galerie.',
      groupe_inconnu: 'Ce groupe n’existe pas.',
      domaine_pris: 'Ce domaine est déjà utilisé par une autre galerie.',
      invalide: 'Valeurs refusées par l’API : {{champs}}.',
      invalideSansChamp: 'Certaines valeurs sont refusées par l’API. Vérifiez la saisie.',
      mfa: 'La vérification du second facteur a échoué. Recommencez.',
      fichier: 'Ce fichier est refusé : un PDF de 20 Mo au plus est attendu.',
    },
    revisionPerimee:
      'Le dossier a changé entre-temps. Il a été rechargé : vérifiez les valeurs, puis enregistrez de nouveau.',

    assistant: {
      titreNouvelle: 'Nouvelle ouverture',
      titreReprise: 'Ouverture {{numero}}',
      texte: 'Six étapes. Chaque étape est enregistrée : vous pouvez reprendre plus tard.',
      aria: 'Étapes de l’ouverture',
      progression: 'Étape {{courante}} sur {{total}}',
      etapes: {
        galerie: 'Galerie',
        offre: 'Offre',
        contrat: 'Contrat',
        equipe: 'Équipe',
        prereglages: 'Préréglages',
        creation: 'Création',
      },
      precedent: 'Précédent',
      continuer: 'Enregistrer et continuer',
      enregistrement: 'Enregistrement…',
      verrouille: 'Disponible une fois la galerie enregistrée.',
      clos: 'Ce dossier est clos : il ne se modifie plus.',
      voirDossier: 'Voir le dossier',
      lectureSeule: 'Votre rôle consulte ce dossier sans pouvoir le modifier.',
      test: {
        info: 'Un espace de test n’a ni contrat ni équipe à saisir : il passe directement à la création.',
        direction: 'Compte de direction de l’espace de test',
        directionAide: 'Ce compte reçoit l’invitation et ouvre l’espace.',
      },
    },

    galerie: {
      titre: 'La galerie',
      texte: 'Qui est la galerie, et sous quel identifiant elle ouvre.',
      nom: 'Nom commercial',
      slug: 'Identifiant (sous-domaine)',
      slugAide: 'Minuscules, chiffres et tirets, 3 à 40 caractères. Proposé depuis le nom.',
      slugFige: 'La galerie est créée : l’identifiant ne change plus.',
      adresseSite: 'Adresse du site',
      verification: 'Vérification…',
      disponible: 'Cet identifiant est disponible.',
      raisons: {
        invalide:
          'Format refusé : 3 à 40 caractères, minuscules, chiffres et tirets, sans tiret au début ni à la fin.',
        reserve: 'Cet identifiant est réservé par la plateforme.',
        pris: 'Cet identifiant est déjà pris.',
      },
      identiteLegale: 'Identité légale',
      raisonSociale: 'Raison sociale',
      formeJuridique: 'Forme juridique',
      siren: 'SIREN',
      sirenAide: '9 chiffres.',
      siret: 'SIRET',
      siretAide: '14 chiffres.',
      tva: 'TVA intracommunautaire',
      tvaAide: 'Deux lettres puis le numéro, sans espace.',
      adresse: 'Adresse',
      ligne1: 'Adresse',
      ligne2: 'Complément',
      codePostal: 'Code postal',
      ville: 'Ville',
      pays: 'Pays (code à deux lettres)',
      reglages: 'Réglages',
      langue: 'Langue',
      devise: 'Devise',
      fuseau: 'Fuseau horaire',
      groupe: 'Groupe',
      groupeAide: 'Facultatif. L’identifiant du groupe qui rassemble plusieurs galeries.',
      estTest: 'Galerie de test',
      estTestAide:
        'Un espace pour essayer la plateforme : aucun contrat, aucune facturation, l’étape de création directement.',
      erreurs: {
        nom: 'Indiquez le nom commercial.',
        slug: 'Indiquez un identifiant valide.',
        siren: 'Le SIREN compte 9 chiffres.',
        siret: 'Le SIRET compte 14 chiffres.',
        tva: 'Deux lettres majuscules puis le numéro, par exemple FR12345678901.',
        pays: 'Deux lettres majuscules, par exemple FR.',
        devise: 'Trois lettres majuscules, par exemple EUR.',
        nomDirection: 'Indiquez le nom de la direction.',
        emailDirection: 'Indiquez une adresse électronique valide.',
      },
      langues: { fr: 'Français', en: 'Anglais' },
    },

    offre: {
      titre: 'L’offre',
      texte: 'Le palier, les modules et les add-ons de la galerie, et ce qui se vend à part.',
      palier: 'Palier',
      palierAide: 'Une donnée commerciale : le palier ne change aucun module.',
      modules: 'Modules complémentaires',
      modulesTexte: 'Le cœur est inclus pour toutes les galeries. Cochez ce que l’offre ajoute.',
      addons: 'Add-ons',
      addonsTexte: 'Achat définitif ou location jusqu’à une échéance.',
      addonsAVenir_one: '{{count}} add-on bientôt disponible',
      addonsAVenir_other: '{{count}} add-ons bientôt disponibles',
      bientot: 'Bientôt',
      necessite: 'Nécessite : {{liste}}',
      dependanceManquante: 'Cochez aussi : {{liste}}.',
      requisPar: 'Requis par {{liste}}',
      mode: 'Mode',
      modes: { achat: 'Achat', location: 'Location', essai: 'Essai' },
      echeance: 'Échéance',
      echeanceAide: 'Une date à venir.',
      erreurEcheance: 'Indiquez une échéance à venir pour {{addon}}.',
      services: 'Services',
      servicesTexte: 'Des prestations à part, facturées hors abonnement.',
      forfait: 'Forfait de reprise',
      forfaitTexte: 'Pour mémoire : la console ne facture rien.',
      forfaitDescription: 'Description',
      forfaitMontant: 'Montant (€)',
      erreurMontant: 'Indiquez un montant en euros, par exemple 1 200 ou 1200,50.',
    },

    contrat: {
      titre: 'Le contrat',
      texte: 'La référence du devis ou du bon de commande, la date de signature et le PDF signé.',
      reference: 'Référence du devis ou du bon de commande',
      signeLe: 'Date de signature',
      piece: 'PDF signé',
      pieceAucune: 'Aucun PDF déposé.',
      pieceDepose: 'Déposé le {{date}} par {{par}} · {{taille}}',
      empreinte: 'Empreinte {{sha}}',
      choisir: 'Choisir le PDF signé',
      deposer: 'Déposer le PDF',
      depot: 'Dépôt…',
      depose: 'PDF déposé.',
      reserveDirection:
        'Le dépôt du PDF est réservé à la direction de Venio, avec une vérification récente du second facteur.',
      fichierAttendu: 'Joignez un fichier PDF.',
      mandatTitre: 'Mandat de reprise',
      mandatTexte:
        'Le mandat qui autorise Venio à reprendre les données se pose dans l’onglet Reprise de la fiche de la galerie, une fois celle-ci créée.',
      mandatLien: 'Ouvrir l’onglet Reprise',
      erreurs: {
        reference: 'Indiquez la référence du contrat.',
        signeLe: 'Indiquez la date de signature.',
      },
      passeSigne: 'Contrat signé enregistré.',
    },

    equipe: {
      titre: 'L’équipe',
      texte: 'La direction de la galerie et ses membres. Chacun reçoit une invitation.',
      direction: 'Direction',
      nom: 'Nom',
      email: 'Adresse électronique',
      membres: 'Membres',
      aucunMembre: 'Aucun membre pour l’instant.',
      ajouter: 'Ajouter un membre',
      retirer: 'Retirer {{nom}}',
      role: 'Rôle',
      roles: {
        direction: 'Direction',
        equipe: 'Équipe',
        lecture: 'Lecture',
        comptable: 'Comptable',
      },
      invitations: 'Envoi des invitations',
      invitationsOptions: {
        maintenant: 'Maintenant, à la création de la galerie',
        a_la_bascule: 'À la bascule, quand la galerie ouvre',
      },
      erreurs: {
        nomDirection: 'Indiquez le nom de la direction.',
        emailDirection: 'Indiquez une adresse électronique valide pour la direction.',
        membre: 'Chaque membre a un nom et une adresse électronique valide.',
        doublon: 'Une même adresse figure deux fois dans l’équipe.',
      },
    },

    prereglages: {
      titre: 'Les préréglages',
      texte: 'Ce que la création écrit chez la galerie. Elle garde la main sur le reste.',
      emetteur: 'Émetteur des factures',
      emetteurTexte: 'Repris de l’identité légale. Modifiez-la dans l’étape Galerie.',
      emetteurVide: 'Aucune identité légale renseignée : la galerie la saisira elle-même.',
      modifierGalerie: 'Modifier l’identité légale',
      mentions: 'Mentions complémentaires',
      mentionsAide: 'Une mention par ligne, 20 au plus. Elles s’ajoutent aux factures.',
      domaine: 'Domaine propre',
      domaineAide: 'Facultatif. Le domaine de la galerie, par exemple www.galerie.fr.',
      note: 'Le numéro de facture, le logo et les coordonnées bancaires restent réglés par la galerie.',
      erreurMentions: 'Vingt mentions au plus, de 500 caractères chacune.',
      raisonSociale: 'Raison sociale',
      forme: 'Forme juridique',
      siren: 'SIREN',
      siret: 'SIRET',
      tva: 'TVA',
      adresse: 'Adresse',
    },

    creation: {
      titre: 'Récapitulatif et création',
      texte:
        'Relisez le dossier. La création enchaîne six sous-étapes et se reprend là où elle s’arrête.',
      sections: {
        galerie: 'Galerie',
        offre: 'Offre',
        contrat: 'Contrat',
        equipe: 'Équipe',
        prereglages: 'Préréglages',
      },
      modifier: 'Modifier',
      nonRenseigne: 'Non renseigné',
      aucun: 'Aucun',
      sansContrat: 'Sans objet pour un espace de test',
      cree: 'Créer la galerie',
      creation: 'Création…',
      reprendre: 'Reprendre',
      reprise: 'Reprise…',
      prerequis: 'Avant de créer',
      manque: {
        slug: 'Un identifiant valide (étape Galerie)',
        nom: 'Le nom commercial (étape Galerie)',
        direction: 'La direction de la galerie (étape Équipe)',
        contrat: 'Le contrat signé : référence et date (étape Contrat)',
      },
      sousEtapes: 'Sous-étapes de la création',
      sousEtape: {
        provisionnement: 'Galerie, base de données et sous-domaine',
        modules: 'Modules complémentaires',
        addons: 'Add-ons',
        domaine: 'Domaine propre',
        invitations: 'Invitations',
        prereglages: 'Préréglages de l’émetteur',
      },
      etat: {
        fait: 'Faite',
        sans_objet: 'Sans objet',
        en_cours: 'En attente',
        refuse: 'Refusée',
        afaire: 'À faire',
      },
      notes: {
        invitations: 'Les invitations partent à la bascule.',
      },
      faitesParAppel: 'Faites par cet appel : {{liste}}.',
      rienAFaire: 'Tout était déjà fait.',
      invitationsEnvoyees_one: '{{count}} invitation envoyée.',
      invitationsEnvoyees_other: '{{count}} invitations envoyées.',
      echec: 'La création s’est arrêtée avant la fin. Les sous-étapes faites restent acquises.',
      termine: 'La galerie est créée.',
      provisionne: 'Le dossier passe à « Provisionnée ».',
      provisionneEchec:
        'La galerie est créée, mais le dossier n’a pas pu passer à « Provisionnée ». Faites-le depuis sa synthèse.',
      ouvrirDossier: 'Ouvrir le dossier',
      ouvrirGalerie: 'Ouvrir la galerie',
    },

    fiche: {
      resume: 'Dossier {{numero}}',
      responsable: 'Responsable',
      creeLe: 'Créé le {{date}}',
      reprendreAssistant: 'Reprendre l’assistant',
      onglets: {
        aria: 'Sections du dossier',
        synthese: 'Synthèse',
        offre: 'Offre et contrat',
        equipe: 'Équipe',
        reprise: 'Reprise',
        recette: 'Recette et bascule',
        journal: 'Journal',
      },
      frise: 'Avancement du dossier',
      abandonne: 'Ce dossier est abandonné.',
      synthese: {
        transitions: 'Étape suivante',
        aucuneTransition: 'Aucune étape à lancer pour le moment.',
        lectureSeule: 'Votre rôle consulte ce dossier sans pouvoir le faire avancer.',
        transition: {
          contrat_signe: 'Marquer le contrat signé',
          provisionne: 'Marquer comme provisionnée',
          reprise: 'Lancer la reprise des données',
          recette: 'Passer à la recette',
          bascule_planifiee: 'Planifier la bascule',
          en_service: 'Mettre en service',
          abandonne: 'Abandonner le dossier',
        },
        succes: 'Le dossier passe à « {{etat}} ».',
        recette: {
          titre: 'Passer à la recette ?',
          texte:
            'La recette s’ouvre quand aucun plan ni travail de reprise ne tourne et que tous les lots lancés sont terminés. Les lots jamais lancés sont mis de côté avec le motif ci-dessous ; sans motif, ils retiennent le passage.',
          motif: 'Motif pour les lots jamais lancés (facultatif)',
          confirmer: 'Passer à la recette',
          annuler: 'Annuler',
          fermer: 'Fermer',
        },
        abandon: {
          titre: 'Abandonner ce dossier ?',
          texte: 'Le dossier est clos et ne se modifie plus. Dites pourquoi, en quelques mots.',
          motif: 'Motif',
          motifErreur: 'Le motif compte au moins trois caractères.',
          confirmer: 'Abandonner',
          annuler: 'Annuler',
          fermer: 'Fermer',
        },
        resiliation: {
          titre: 'La galerie existe toujours.',
          texte:
            'Abandonner le dossier ne résilie rien. Résiliez la galerie par son parcours, avec son export et sa confirmation.',
          lien: 'Ouvrir l’onglet Résiliation',
        },
        controle: 'Liste de contrôle',
        controleTexte: 'Les sous-étapes de la création de la galerie.',
        jalons: 'Jalons',
        basculePrevue: 'Bascule prévue',
        basculeEffectuee: 'Bascule effectuée',
        scelle: 'Données scellées',
        purge: 'Purge des sources',
        nonDate: 'À venir',
        enregistrerJalon: 'Enregistrer la date',
        jalonEnregistre: 'Date de bascule enregistrée.',
        notes: 'Notes',
        notesVide: 'Aucune note.',
        noteChamp: 'Ajouter une note',
        noteAjouter: 'Ajouter la note',
        noteParLe: '{{par}} · {{date}}',
        noteEnregistree: 'Note ajoutée.',
      },
      offreContrat: {
        identite: 'Identité',
        offre: 'Offre',
        contrat: 'Contrat',
        palier: 'Palier',
        modules: 'Modules complémentaires',
        addons: 'Add-ons',
        services: 'Services à part',
        forfait: 'Forfait de reprise',
        groupe: 'Groupe',
        slug: 'Identifiant',
        raisonSociale: 'Raison sociale',
        siren: 'SIREN',
        siret: 'SIRET',
        tva: 'TVA intracommunautaire',
        adresse: 'Adresse',
        langue: 'Langue, devise, fuseau',
        reference: 'Référence',
        signeLe: 'Signé le',
        piece: 'PDF signé',
        aucun: 'Aucun',
        modifier: 'Modifier dans l’assistant',
        verrouille: 'La galerie est créée : modifiez-la depuis sa propre fiche.',
        jusquAu: 'jusqu’au {{date}}',
        prereglages: 'Préréglages',
        mentions: 'Mentions complémentaires',
        domaine: 'Domaine propre',
      },
      equipe: {
        direction: 'Direction',
        membres: 'Membres',
        invitations: 'Envoi des invitations',
        vide: 'Aucune équipe saisie.',
        colonnes: { nom: 'Nom', email: 'Adresse électronique', role: 'Rôle' },
      },
      reprise: {
        titre: 'Reprise des données',
        texte:
          'La reprise (mandat, dépôts, lots) se conduit depuis l’onglet Reprise de la fiche de la galerie.',
        ouvrir: 'Ouvrir l’onglet Reprise',
        attente: 'La reprise s’ouvre une fois la galerie créée.',
      },
      recette: {
        attente: 'La recette s’ouvre une fois la galerie créée.',
        chargement: 'Chargement de la recette…',
        erreurChargement: 'Impossible de lire la recette de ce dossier.',
        lectureSeule: 'Votre rôle consulte la recette sans pouvoir la modifier.',
        tableau: {
          titre: 'Tableau de contrôle',
          texte:
            'Ce que la reprise a laissé dans la galerie, nature par nature. L’écart est le total moins tout ce qui est expliqué : créés, complétés, ignorés, refusés et écartés.',
          libelle: 'Tableau de contrôle par nature',
          vide: 'Aucun lot exécuté pour l’instant.',
          colonnes: {
            nature: 'Nature',
            lots: 'Lots',
            total: 'Total',
            crees: 'Créés',
            completes: 'Complétés',
            ignores: 'Ignorés',
            refuses: 'Refusés',
            ecartes: 'Écartés',
            ecart: 'Écart',
            aRevoir: 'À revoir',
          },
          total: 'Total',
          ecartNul: 'Aucun écart',
          ecartNonNul_one: '{{count}} enregistrement sans explication',
          ecartNonNul_other: '{{count}} enregistrements sans explication',
          motifs: 'Motifs d’écartement',
          sansMotif: 'Aucun motif enregistré : cet écart reste à expliquer.',
          alerte_one:
            '{{count}} nature ne tombe pas juste. Expliquez l’écart avec la galerie avant de basculer.',
          alerte_other:
            '{{count}} natures ne tombent pas juste. Expliquez les écarts avec la galerie avant de basculer.',
          aRevoir_one: '{{count}} enregistrement reste à revoir (delta).',
          aRevoir_other: '{{count}} enregistrements restent à revoir (delta).',
        },
        lots: {
          titre: 'État des lots',
          executes: 'Exécutés',
          annules: 'Annulés',
          misDeCote: 'Mis de côté',
          enCours: 'En cours',
          nonLances: 'Non lancés',
          plan: 'Plan de reprise',
          planActif: 'Actif',
          planInactif: 'Aucun',
          listeMisDeCote: 'Lots mis de côté',
          listeEnCours: 'Lots lancés et pas terminés',
          listeNonLances: 'Lots jamais lancés',
          ouvrir: 'Ouvrir le lot {{nature}}',
          tousTermines: 'Tous les lots sont terminés, annulés ou mis de côté.',
          retenus: 'Ces lots retiennent la recette et la bascule.',
        },
        controles: {
          titre: 'Liste de contrôle',
          texte:
            'Quatre vérifications faites avec la galerie. L’opérateur ne voit pas les fiches : il coche ce que la galerie a constaté.',
          liste: 'Vérifications de la recette',
          cles: {
            historique_localisations: 'Historique des localisations présent',
            echantillon_fiches: 'Échantillon de 10 fiches par nature',
            images_principales: 'Images principales présentes',
            factures_anterieures: 'Factures antérieures lisibles',
          },
          note: 'Note (facultative)',
          notePour: 'Note pour « {{controle}} »',
          parLe: '{{par}}, le {{date}}',
          aFaire: 'À faire',
          fermee:
            'La liste de contrôle se coche pendant la reprise, la recette et avant la bascule.',
          cochee: 'Case cochée.',
          decochee: 'Case décochée.',
        },
        validation: {
          titre: 'Validation de la galerie',
          enAttente: 'En attente',
          validee: 'Validée',
          texteAttente:
            'La galerie voit une carte « Reprise de vos données » dans sa régie : elle valide la reprise, ou signale un problème.',
          parLe: 'Validée par {{par}}, le {{date}}.',
          controlesFiges: '{{count}} cases sur 4 cochées au moment de la validation.',
          pv: 'Procès-verbal',
          pvCoffre: 'Produit le {{date}}, rangé dans le coffre de la galerie.',
          pvDocuments: 'Produit le {{date}}, rangé dans les documents de la galerie.',
          pvAttente: 'En cours de production.',
          signalements: 'Signalements de la galerie',
          aucunSignalement: 'La galerie n’a rien signalé.',
          signalePar: '{{par}}, le {{date}}',
        },
        derogation: {
          titre: 'Dérogation',
          texte:
            'Si la galerie ne valide pas et que la bascule ne peut pas attendre, la direction de Venio passe outre, avec un motif.',
          action: 'Passer outre la validation',
          posee: 'Dérogation posée par {{par}}, le {{date}}.',
          motifPose: 'Motif',
          dialogue: {
            titre: 'Passer outre la validation de la galerie ?',
            texte:
              'La bascule pourra être planifiée sans l’accord de la galerie. Le motif est gardé au dossier et au journal.',
            motif: 'Motif',
            aide: 'Huit caractères au moins.',
            erreur: 'Le motif compte au moins huit caractères.',
            confirmer: 'Poser la dérogation',
            annuler: 'Annuler',
            fermer: 'Fermer',
          },
          ok: 'Dérogation posée.',
        },
        bascule: {
          titre: 'Bascule',
          prevue: 'Date prévue',
          nonDatee: 'Non planifiée',
          modifier: 'Modifier dans la synthèse',
          effectuee: 'Basculée le',
          enService: 'La galerie est en service.',
          avant:
            'La bascule se lance quand le dossier est à l’état « Bascule planifiée ». Planifiez-la depuis la synthèse.',
          lectureSeule: 'Seule la direction de Venio bascule une galerie.',
          action: 'Basculer',
          reprendre: 'Reprendre la bascule',
          enCours: 'Bascule en cours…',
          etapes: 'Étapes de la bascule',
          etat: {
            faite: 'Faite',
            erreur: 'En erreur',
            en_cours: 'En cours',
            attente: 'À faire',
          },
          etape: {
            controle: 'Contrôle final',
            scellement: 'Scellement des données',
            mandat: 'Mandat ramené à la bascule + 30 jours',
            purge: 'Purge des sources planifiée',
            invitations: 'Invitations envoyées',
            mise_en_service: 'Mise en service',
          },
          erreurTitre: 'La bascule s’est arrêtée à l’étape « {{etape}} ».',
          erreurAide:
            'Les étapes faites sont gardées. Corrigez la cause, puis reprenez : la bascule saute ce qui est fait.',
          ok: 'La galerie est en service.',
          confirmation: {
            titre: 'Basculer {{nom}} ?',
            titreReprise: 'Reprendre la bascule de {{nom}} ?',
            texte: 'La bascule fait, dans cet ordre :',
            texteReprise: 'La bascule saute ce qui est fait et reprend là où elle s’est arrêtée :',
            faite: 'déjà faite',
            pas: {
              controle:
                'Contrôle final : aucun plan, lot ni travail de reprise ne tourne. Les enregistrements à revoir sont comptés.',
              scellement:
                'Scellement des données reprises : plus aucun lot ne s’annule. Il précède les invitations, pour que personne n’arrive sur une galerie à moitié basculée.',
              mandat: 'Le mandat de reprise est ramené à la date de bascule + 30 jours.',
              purge: 'La purge des sources est planifiée à la date de bascule + 30 jours.',
              invitations: 'Les invitations différées sont envoyées à la direction et à l’équipe.',
            },
            final: 'Le dossier passe ensuite « En service ».',
            irreversible:
              'Irréversible. Une panne se reprend, mais le scellement ne se défait pas et les invitations ne se rappellent pas.',
            confirmer: 'Basculer la galerie',
            annuler: 'Annuler',
            fermer: 'Fermer',
          },
        },
      },
      journal: {
        attente: 'Le journal de la galerie se remplit une fois la galerie créée.',
      },
    },

    bandeau: {
      titre: 'Mise en service en cours.',
      texte: 'Dossier {{numero}} : {{etat}}.',
      lien: 'Ouvrir le dossier',
    },
  },
};

export const enOuvertures = {
  ouvertures: {
    titre: 'Onboardings',
    texte: 'The go-live files, from the signed offer to the open gallery.',
    nouvelle: 'New onboarding',
    retour: 'Back to onboardings',
    chargement: 'Loading files…',
    erreurChargement: 'Unable to read the onboarding files.',
    introuvable: 'This onboarding file cannot be found.',
    vide: 'No file matches these filters.',
    videTout: 'No onboarding file yet. Start with a new onboarding.',
    test: 'Test',
    filtres: {
      etat: 'Status',
      tousEtats: 'All statuses',
      responsable: 'Owner',
      tous: 'All',
      moi: 'My files',
    },
    colonnes: {
      numero: 'File',
      nom: 'Gallery',
      etat: 'Status',
      responsable: 'Owner',
      bascule: 'Planned switchover',
      prochaine: 'Next action',
    },
    pagination: {
      page: 'Page {{page}} of {{total}}',
      precedente: 'Previous page',
      suivante: 'Next page',
    },
    sansResponsable: 'Unassigned',
    sansDate: 'Not scheduled',
    retard_one: '{{count}} day late',
    retard_other: '{{count}} days late',
    etat: {
      brouillon: 'Draft',
      contrat_signe: 'Contract signed',
      provisionne: 'Provisioned',
      reprise: 'Data migration',
      recette: 'Acceptance',
      bascule_planifiee: 'Switchover scheduled',
      en_service: 'Live',
      abandonne: 'Abandoned',
    },
    prochaineAction: {
      brouillon: 'Finish the wizard',
      brouillonTest: 'Create the test space',
      contrat_signe: 'Create the gallery',
      provisionne: 'Start the data migration',
      reprise: 'Follow the data migration',
      recette: 'Run the acceptance',
      bascule_planifiee: 'Prepare the switchover',
      en_service: 'None',
      abandonne: 'None',
    },
    erreurs: {
      generique: 'The operation failed. Try again.',
      reseau: 'The connection to the console failed. Try again.',
      droits: 'Your role does not allow this action.',
      dossier_clos: 'This file is closed (live or abandoned): it can no longer be edited.',
      slug_fige: 'The gallery is created: its identifier no longer changes.',
      slug_pris: 'This identifier is already taken.',
      contrat_incomplet: 'Enter the contract reference and its signature date.',
      provisionnement_incomplet: 'The gallery is not fully created: finish the creation.',
      transition_interdite: 'This file cannot move to that status from its current one.',
      bascule_requise: 'Going live only happens through the switchover, from the Acceptance tab.',
      lots_non_termines:
        'Some batches are not finished: {{lots}}. Run or cancel them; a batch that never started is set aside when moving to acceptance with a reason.',
      reprise_en_cours:
        'A plan or a migration job still occupies the gallery: wait for it to finish.',
      galerie_absente: 'This file has no gallery yet: nothing to accept.',
      validation_requise:
        'The gallery has not approved the migration. Wait for its approval, or record an override (Venio management) from the Acceptance tab.',
      bascule_non_datee: 'Enter the planned switchover date, in the file summary.',
      recette_non_ouverte: 'The migration is not in acceptance: there is nothing to approve.',
      invitations_non_envoyees:
        'Some invitations did not go out. The steps already done are kept: resume the switchover.',
      delta_inacheve: 'Some batches are running unfinished: the final check is not done.',
      bascule_en_cours: 'This gallery’s switchover is already running or was resumed elsewhere.',
      mandat_concurrent: 'The mandate just changed: resume the switchover.',
      lot_modifie: 'A batch just changed: reload, then try again.',
      dossier_incomplet: 'The file is not enough to create the gallery. Missing: {{manquants}}.',
      creation_en_cours: 'This gallery is already being created. Wait, then resume.',
      etat_incompatible:
        'The gallery is created once the contract is signed, or right away for a test space.',
      module_non_disponible: 'A module of the offer is not delivered yet.',
      addon_echeance_passee: 'An add-on’s end date has passed: correct the offer.',
      membre_en_double: 'The same address appears twice in the team.',
      role_plateforme_existant:
        'This address already holds a platform role: it cannot join a gallery.',
      groupe_inconnu: 'This group does not exist.',
      domaine_pris: 'This domain is already used by another gallery.',
      invalide: 'Values refused by the API: {{champs}}.',
      invalideSansChamp: 'Some values were refused by the API. Check the entry.',
      mfa: 'The second-factor check failed. Try again.',
      fichier: 'This file is refused: a PDF of 20 MB or less is expected.',
    },
    revisionPerimee:
      'The file changed in the meantime. It has been reloaded: check the values, then save again.',

    assistant: {
      titreNouvelle: 'New onboarding',
      titreReprise: 'Onboarding {{numero}}',
      texte: 'Six steps. Each step is saved: you can resume later.',
      aria: 'Onboarding steps',
      progression: 'Step {{courante}} of {{total}}',
      etapes: {
        galerie: 'Gallery',
        offre: 'Offer',
        contrat: 'Contract',
        equipe: 'Team',
        prereglages: 'Presets',
        creation: 'Creation',
      },
      precedent: 'Previous',
      continuer: 'Save and continue',
      enregistrement: 'Saving…',
      verrouille: 'Available once the gallery is saved.',
      clos: 'This file is closed: it can no longer be edited.',
      voirDossier: 'View the file',
      lectureSeule: 'Your role can read this file but not change it.',
      test: {
        info: 'A test space has no contract or team to enter: it goes straight to creation.',
        direction: 'Test space direction account',
        directionAide: 'This account receives the invitation and opens the space.',
      },
    },

    galerie: {
      titre: 'The gallery',
      texte: 'Who the gallery is, and the identifier it opens under.',
      nom: 'Trade name',
      slug: 'Identifier (subdomain)',
      slugAide:
        'Lowercase letters, digits and hyphens, 3 to 40 characters. Suggested from the name.',
      slugFige: 'The gallery is created: the identifier no longer changes.',
      adresseSite: 'Site address',
      verification: 'Checking…',
      disponible: 'This identifier is available.',
      raisons: {
        invalide:
          'Format refused: 3 to 40 characters, lowercase letters, digits and hyphens, no hyphen at the start or end.',
        reserve: 'This identifier is reserved by the platform.',
        pris: 'This identifier is already taken.',
      },
      identiteLegale: 'Legal identity',
      raisonSociale: 'Company name',
      formeJuridique: 'Legal form',
      siren: 'SIREN',
      sirenAide: '9 digits.',
      siret: 'SIRET',
      siretAide: '14 digits.',
      tva: 'VAT number',
      tvaAide: 'Two letters then the number, no spaces.',
      adresse: 'Address',
      ligne1: 'Address',
      ligne2: 'Address line 2',
      codePostal: 'Postal code',
      ville: 'City',
      pays: 'Country (two-letter code)',
      reglages: 'Settings',
      langue: 'Language',
      devise: 'Currency',
      fuseau: 'Time zone',
      groupe: 'Group',
      groupeAide: 'Optional. The identifier of the group that gathers several galleries.',
      estTest: 'Test gallery',
      estTestAide:
        'A space to try the platform: no contract, no billing, straight to the creation step.',
      erreurs: {
        nom: 'Enter the trade name.',
        slug: 'Enter a valid identifier.',
        siren: 'A SIREN has 9 digits.',
        siret: 'A SIRET has 14 digits.',
        tva: 'Two capital letters then the number, for example FR12345678901.',
        pays: 'Two capital letters, for example FR.',
        devise: 'Three capital letters, for example EUR.',
        nomDirection: 'Enter the direction’s name.',
        emailDirection: 'Enter a valid email address.',
      },
      langues: { fr: 'French', en: 'English' },
    },

    offre: {
      titre: 'The offer',
      texte: 'The tier, modules and add-ons of the gallery, and what is sold separately.',
      palier: 'Tier',
      palierAide: 'A commercial data point: the tier changes no module.',
      modules: 'Additional modules',
      modulesTexte: 'The core is included for every gallery. Tick what the offer adds.',
      addons: 'Add-ons',
      addonsTexte: 'Outright purchase or rental until an end date.',
      addonsAVenir_one: '{{count}} add-on coming soon',
      addonsAVenir_other: '{{count}} add-ons coming soon',
      bientot: 'Coming soon',
      necessite: 'Requires: {{liste}}',
      dependanceManquante: 'Also tick: {{liste}}.',
      requisPar: 'Required by {{liste}}',
      mode: 'Mode',
      modes: { achat: 'Purchase', location: 'Rental', essai: 'Trial' },
      echeance: 'End date',
      echeanceAide: 'A future date.',
      erreurEcheance: 'Enter a future end date for {{addon}}.',
      services: 'Services',
      servicesTexte: 'Sold separately, billed outside the subscription.',
      forfait: 'Migration package',
      forfaitTexte: 'For the record: the console bills nothing.',
      forfaitDescription: 'Description',
      forfaitMontant: 'Amount (€)',
      erreurMontant: 'Enter an amount in euros, for example 1,200 or 1200.50.',
    },

    contrat: {
      titre: 'The contract',
      texte: 'The quote or purchase order reference, the signature date and the signed PDF.',
      reference: 'Quote or purchase order reference',
      signeLe: 'Signature date',
      piece: 'Signed PDF',
      pieceAucune: 'No PDF uploaded.',
      pieceDepose: 'Uploaded on {{date}} by {{par}} · {{taille}}',
      empreinte: 'Fingerprint {{sha}}',
      choisir: 'Choose the signed PDF',
      deposer: 'Upload the PDF',
      depot: 'Uploading…',
      depose: 'PDF uploaded.',
      reserveDirection:
        'Uploading the PDF is reserved for Venio’s direction, with a recent second-factor check.',
      fichierAttendu: 'Attach a PDF file.',
      mandatTitre: 'Migration mandate',
      mandatTexte:
        'The mandate that lets Venio migrate the data is set in the Migration tab of the gallery page, once the gallery is created.',
      mandatLien: 'Open the Migration tab',
      erreurs: {
        reference: 'Enter the contract reference.',
        signeLe: 'Enter the signature date.',
      },
      passeSigne: 'Signed contract recorded.',
    },

    equipe: {
      titre: 'The team',
      texte: 'The gallery’s direction and its members. Each receives an invitation.',
      direction: 'Direction',
      nom: 'Name',
      email: 'Email address',
      membres: 'Members',
      aucunMembre: 'No member yet.',
      ajouter: 'Add a member',
      retirer: 'Remove {{nom}}',
      role: 'Role',
      roles: {
        direction: 'Direction',
        equipe: 'Team',
        lecture: 'Read-only',
        comptable: 'Accountant',
      },
      invitations: 'Sending invitations',
      invitationsOptions: {
        maintenant: 'Now, when the gallery is created',
        a_la_bascule: 'At switchover, when the gallery opens',
      },
      erreurs: {
        nomDirection: 'Enter the direction’s name.',
        emailDirection: 'Enter a valid email address for the direction.',
        membre: 'Each member needs a name and a valid email address.',
        doublon: 'The same address appears twice in the team.',
      },
    },

    prereglages: {
      titre: 'The presets',
      texte: 'What the creation writes to the gallery. It keeps control of the rest.',
      emetteur: 'Invoice issuer',
      emetteurTexte: 'Taken from the legal identity. Change it in the Gallery step.',
      emetteurVide: 'No legal identity entered: the gallery will enter it itself.',
      modifierGalerie: 'Edit the legal identity',
      mentions: 'Additional notices',
      mentionsAide: 'One notice per line, 20 at most. They are added to invoices.',
      domaine: 'Custom domain',
      domaineAide: 'Optional. The gallery’s domain, for example www.gallery.com.',
      note: 'The invoice number, the logo and the bank details stay set by the gallery.',
      erreurMentions: 'Twenty notices at most, 500 characters each.',
      raisonSociale: 'Company name',
      forme: 'Legal form',
      siren: 'SIREN',
      siret: 'SIRET',
      tva: 'VAT',
      adresse: 'Address',
    },

    creation: {
      titre: 'Summary and creation',
      texte: 'Review the file. The creation runs six sub-steps and resumes where it stopped.',
      sections: {
        galerie: 'Gallery',
        offre: 'Offer',
        contrat: 'Contract',
        equipe: 'Team',
        prereglages: 'Presets',
      },
      modifier: 'Edit',
      nonRenseigne: 'Not entered',
      aucun: 'None',
      sansContrat: 'Not applicable to a test space',
      cree: 'Create the gallery',
      creation: 'Creating…',
      reprendre: 'Resume',
      reprise: 'Resuming…',
      prerequis: 'Before creating',
      manque: {
        slug: 'A valid identifier (Gallery step)',
        nom: 'The trade name (Gallery step)',
        direction: 'The gallery’s direction (Team step)',
        contrat: 'The signed contract: reference and date (Contract step)',
      },
      sousEtapes: 'Creation sub-steps',
      sousEtape: {
        provisionnement: 'Gallery, database and subdomain',
        modules: 'Additional modules',
        addons: 'Add-ons',
        domaine: 'Custom domain',
        invitations: 'Invitations',
        prereglages: 'Issuer presets',
      },
      etat: {
        fait: 'Done',
        sans_objet: 'Not applicable',
        en_cours: 'Pending',
        refuse: 'Refused',
        afaire: 'To do',
      },
      notes: {
        invitations: 'Invitations go out at switchover.',
      },
      faitesParAppel: 'Done by this call: {{liste}}.',
      rienAFaire: 'Everything was already done.',
      invitationsEnvoyees_one: '{{count}} invitation sent.',
      invitationsEnvoyees_other: '{{count}} invitations sent.',
      echec: 'The creation stopped before the end. Sub-steps already done stay done.',
      termine: 'The gallery is created.',
      provisionne: 'The file moves to “Provisioned”.',
      provisionneEchec:
        'The gallery is created, but the file could not move to “Provisioned”. Do it from its summary.',
      ouvrirDossier: 'Open the file',
      ouvrirGalerie: 'Open the gallery',
    },

    fiche: {
      resume: 'File {{numero}}',
      responsable: 'Owner',
      creeLe: 'Created on {{date}}',
      reprendreAssistant: 'Resume the wizard',
      onglets: {
        aria: 'File sections',
        synthese: 'Summary',
        offre: 'Offer and contract',
        equipe: 'Team',
        reprise: 'Migration',
        recette: 'Acceptance and switchover',
        journal: 'Log',
      },
      frise: 'File progress',
      abandonne: 'This file is abandoned.',
      synthese: {
        transitions: 'Next step',
        aucuneTransition: 'No step to launch for now.',
        lectureSeule: 'Your role can read this file but not move it forward.',
        transition: {
          contrat_signe: 'Mark the contract signed',
          provisionne: 'Mark as provisioned',
          reprise: 'Start the data migration',
          recette: 'Move to acceptance',
          bascule_planifiee: 'Schedule the switchover',
          en_service: 'Go live',
          abandonne: 'Abandon the file',
        },
        succes: 'The file moves to “{{etat}}”.',
        recette: {
          titre: 'Move to acceptance?',
          texte:
            'Acceptance opens when no plan or migration job is running and every batch that started is finished. Batches that never started are set aside with the reason below; without one, they hold the file back.',
          motif: 'Reason for batches that never started (optional)',
          confirmer: 'Move to acceptance',
          annuler: 'Cancel',
          fermer: 'Close',
        },
        abandon: {
          titre: 'Abandon this file?',
          texte: 'The file is closed and can no longer be edited. Say why, in a few words.',
          motif: 'Reason',
          motifErreur: 'The reason needs at least three characters.',
          confirmer: 'Abandon',
          annuler: 'Cancel',
          fermer: 'Close',
        },
        resiliation: {
          titre: 'The gallery still exists.',
          texte:
            'Abandoning the file terminates nothing. Terminate the gallery through its own flow, with its export and confirmation.',
          lien: 'Open the Termination tab',
        },
        controle: 'Checklist',
        controleTexte: 'The sub-steps of the gallery creation.',
        jalons: 'Milestones',
        basculePrevue: 'Planned switchover',
        basculeEffectuee: 'Switchover done',
        scelle: 'Data sealed',
        purge: 'Source purge',
        nonDate: 'Upcoming',
        enregistrerJalon: 'Save the date',
        jalonEnregistre: 'Switchover date saved.',
        notes: 'Notes',
        notesVide: 'No note.',
        noteChamp: 'Add a note',
        noteAjouter: 'Add the note',
        noteParLe: '{{par}} · {{date}}',
        noteEnregistree: 'Note added.',
      },
      offreContrat: {
        identite: 'Identity',
        offre: 'Offer',
        contrat: 'Contract',
        palier: 'Tier',
        modules: 'Additional modules',
        addons: 'Add-ons',
        services: 'Separate services',
        forfait: 'Migration package',
        groupe: 'Group',
        slug: 'Identifier',
        raisonSociale: 'Company name',
        siren: 'SIREN',
        siret: 'SIRET',
        tva: 'VAT number',
        adresse: 'Address',
        langue: 'Language, currency, time zone',
        reference: 'Reference',
        signeLe: 'Signed on',
        piece: 'Signed PDF',
        aucun: 'None',
        modifier: 'Edit in the wizard',
        verrouille: 'The gallery is created: edit it from its own page.',
        jusquAu: 'until {{date}}',
        prereglages: 'Presets',
        mentions: 'Additional notices',
        domaine: 'Custom domain',
      },
      equipe: {
        direction: 'Direction',
        membres: 'Members',
        invitations: 'Sending invitations',
        vide: 'No team entered.',
        colonnes: { nom: 'Name', email: 'Email address', role: 'Role' },
      },
      reprise: {
        titre: 'Data migration',
        texte:
          'The migration (mandate, uploads, batches) is run from the Migration tab of the gallery page.',
        ouvrir: 'Open the Migration tab',
        attente: 'The migration opens once the gallery is created.',
      },
      recette: {
        attente: 'Acceptance opens once the gallery is created.',
        chargement: 'Loading acceptance…',
        erreurChargement: 'Unable to read this file’s acceptance.',
        lectureSeule: 'Your role can read acceptance but not change it.',
        tableau: {
          titre: 'Control table',
          texte:
            'What the migration left in the gallery, one type of record at a time. The gap is the total minus everything accounted for: created, completed, skipped, rejected and set aside.',
          libelle: 'Control table by type of record',
          vide: 'No batch has run yet.',
          colonnes: {
            nature: 'Type',
            lots: 'Batches',
            total: 'Total',
            crees: 'Created',
            completes: 'Completed',
            ignores: 'Skipped',
            refuses: 'Rejected',
            ecartes: 'Set aside',
            ecart: 'Gap',
            aRevoir: 'To review',
          },
          total: 'Total',
          ecartNul: 'No gap',
          ecartNonNul_one: '{{count}} record unexplained',
          ecartNonNul_other: '{{count}} records unexplained',
          motifs: 'Reasons for setting aside',
          sansMotif: 'No reason recorded: this gap is still to be explained.',
          alerte_one:
            '{{count}} type of record does not add up. Explain the gap with the gallery before switching over.',
          alerte_other:
            '{{count}} types of record do not add up. Explain the gaps with the gallery before switching over.',
          aRevoir_one: '{{count}} record is still to review (delta).',
          aRevoir_other: '{{count}} records are still to review (delta).',
        },
        lots: {
          titre: 'Batch status',
          executes: 'Run',
          annules: 'Cancelled',
          misDeCote: 'Set aside',
          enCours: 'In progress',
          nonLances: 'Not started',
          plan: 'Migration plan',
          planActif: 'Active',
          planInactif: 'None',
          listeMisDeCote: 'Batches set aside',
          listeEnCours: 'Batches started and not finished',
          listeNonLances: 'Batches never started',
          ouvrir: 'Open the {{nature}} batch',
          tousTermines: 'Every batch is finished, cancelled or set aside.',
          retenus: 'These batches hold acceptance and the switchover back.',
        },
        controles: {
          titre: 'Checklist',
          texte:
            'Four checks made with the gallery. The operator does not see the records: they tick what the gallery has confirmed.',
          liste: 'Acceptance checks',
          cles: {
            historique_localisations: 'Location history is present',
            echantillon_fiches: 'Sample of 10 records per type',
            images_principales: 'Main images are present',
            factures_anterieures: 'Earlier invoices are readable',
          },
          note: 'Note (optional)',
          notePour: 'Note for “{{controle}}”',
          parLe: '{{par}}, on {{date}}',
          aFaire: 'To do',
          fermee: 'The checklist is ticked during migration, acceptance and before the switchover.',
          cochee: 'Box ticked.',
          decochee: 'Box unticked.',
        },
        validation: {
          titre: 'Gallery approval',
          enAttente: 'Waiting',
          validee: 'Approved',
          texteAttente:
            'The gallery sees a “Migration of your data” card in its back office: it approves the migration, or reports a problem.',
          parLe: 'Approved by {{par}}, on {{date}}.',
          controlesFiges: '{{count}} boxes out of 4 ticked when it was approved.',
          pv: 'Report',
          pvCoffre: 'Produced on {{date}}, filed in the gallery’s vault.',
          pvDocuments: 'Produced on {{date}}, filed in the gallery’s documents.',
          pvAttente: 'Being produced.',
          signalements: 'Reports from the gallery',
          aucunSignalement: 'The gallery has reported nothing.',
          signalePar: '{{par}}, on {{date}}',
        },
        derogation: {
          titre: 'Override',
          texte:
            'If the gallery does not approve and the switchover cannot wait, Venio management overrides it, with a reason.',
          action: 'Override the approval',
          posee: 'Override recorded by {{par}}, on {{date}}.',
          motifPose: 'Reason',
          dialogue: {
            titre: 'Override the gallery’s approval?',
            texte:
              'The switchover can be scheduled without the gallery’s agreement. The reason is kept on the file and in the log.',
            motif: 'Reason',
            aide: 'At least eight characters.',
            erreur: 'The reason needs at least eight characters.',
            confirmer: 'Record the override',
            annuler: 'Cancel',
            fermer: 'Close',
          },
          ok: 'Override recorded.',
        },
        bascule: {
          titre: 'Switchover',
          prevue: 'Planned date',
          nonDatee: 'Not scheduled',
          modifier: 'Change in the summary',
          effectuee: 'Switched over on',
          enService: 'The gallery is live.',
          avant:
            'The switchover can start once the file is at “Switchover scheduled”. Schedule it from the summary.',
          lectureSeule: 'Only Venio management switches a gallery over.',
          action: 'Switch over',
          reprendre: 'Resume the switchover',
          enCours: 'Switchover in progress…',
          etapes: 'Switchover steps',
          etat: {
            faite: 'Done',
            erreur: 'Failed',
            en_cours: 'In progress',
            attente: 'To do',
          },
          etape: {
            controle: 'Final check',
            scellement: 'Sealing the data',
            mandat: 'Mandate cut to switchover + 30 days',
            purge: 'Source purge scheduled',
            invitations: 'Invitations sent',
            mise_en_service: 'Going live',
          },
          erreurTitre: 'The switchover stopped at the “{{etape}}” step.',
          erreurAide:
            'The steps already done are kept. Fix the cause, then resume: the switchover skips what is done.',
          ok: 'The gallery is live.',
          confirmation: {
            titre: 'Switch {{nom}} over?',
            titreReprise: 'Resume the switchover of {{nom}}?',
            texte: 'The switchover does the following, in this order:',
            texteReprise: 'The switchover skips what is done and resumes where it stopped:',
            faite: 'already done',
            pas: {
              controle:
                'Final check: no plan, batch or migration job is running. Records to review are counted.',
              scellement:
                'Sealing the migrated data: no batch can be cancelled any more. It comes before the invitations, so nobody lands on a half-switched gallery.',
              mandat: 'The migration mandate is cut to the switchover date + 30 days.',
              purge: 'The source purge is scheduled for the switchover date + 30 days.',
              invitations: 'The deferred invitations are sent to management and the team.',
            },
            final: 'The file then moves to “Live”.',
            irreversible:
              'Irreversible. A failure can be resumed, but the sealing cannot be undone and invitations cannot be recalled.',
            confirmer: 'Switch the gallery over',
            annuler: 'Cancel',
            fermer: 'Close',
          },
        },
      },
      journal: {
        attente: 'The gallery log fills up once the gallery is created.',
      },
    },

    bandeau: {
      titre: 'Go-live in progress.',
      texte: 'File {{numero}}: {{etat}}.',
      lien: 'Open the file',
    },
  },
};
